import { computed, defineComponent, h, reactive } from 'vue';

const defaultOptions = {
  canSuccess: true,
  show: false,
  color: '#73ccec',
  failedColor: 'red',
  height: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};

function createProgressApi (state) {
  return {
    start () {
      state.percent = 30;
      state.options.show = true;
      state.options.canSuccess = true;
    },
    finish () {
      state.percent = 100;
      state.options.show = true;
      state.options.canSuccess = true;
      setTimeout(() => {
        state.options.show = false;
        state.percent = 0;
      }, state.options.transition.termination);
    },
    fail () {
      state.percent = 100;
      state.options.show = true;
      state.options.canSuccess = false;
      setTimeout(() => {
        state.options.show = false;
        state.percent = 0;
        state.options.canSuccess = true;
      }, state.options.transition.termination);
    },
    set (value) {
      state.percent = Math.max(0, Math.min(100, Math.floor(value)));
      state.options.show = true;
    },
    get () {
      return Math.floor(state.percent);
    }
  };
}

const ProgressBarComponent = defineComponent({
  name: 'VueProgressBar',
  props: {
    progress: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const style = computed(() => {
      const { percent, options } = props.progress;
      const nextStyle = {
        position: 'fixed',
        opacity: options.show ? 1 : 0,
        zIndex: 999999,
        backgroundColor: options.canSuccess ? options.color : options.failedColor,
        transition: `width ${options.transition.speed}, height ${options.transition.speed}, opacity ${options.transition.opacity}`,
        left: '0px',
        width: `${percent}%`,
        height: options.height
      };

      if (options.location === 'bottom') {
        nextStyle.bottom = '0px';
      } else {
        nextStyle.top = '0px';
      }

      return nextStyle;
    });

    return () => h('div', {
      class: '__cov-progress',
      style: style.value
    });
  }
});

export default {
  install (app, options = {}) {
    const state = reactive({
      percent: 0,
      options: {
        ...defaultOptions,
        ...options,
        transition: {
          ...defaultOptions.transition,
          ...(options.transition || {})
        }
      }
    });

    const progressApi = createProgressApi(state);
    app.component('vue-progress-bar', defineComponent({
      name: 'VueProgressBarHost',
      setup () {
        return () => h(ProgressBarComponent, { progress: state });
      }
    }));
    app.config.globalProperties.$Progress = progressApi;
  }
};
